<div id="wrapper" class="app-home">
  <div class="d-flex flex-column" id="content-wrapper">
    <div id="content" class="headerbghcolor">
      <section>
        <div class="container-md">
          <div class="row mb-5" style="margin-top: 40px">
            <div class="col-12 text-center col-md-12 col-lg-12">
              <h5
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-once="true"
                class="text-dark mb-2 font-weight-bold"
              >
                Mon espace client FIPARCO<br />
              </h5>
              <p
                class="lead text-light d-none d-md-inline-block text-dark m-3"
                data-aos="fade"
                data-aos-delay="850"
                data-aos-once="true"
              >
                Obtenez des prévisions, utilisez des données concrètes, afin de
                prendre de meilleures décisions.<br />
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- Questionnaire client ECF (spec 010, FR-001) -->
      <div class="container-md mb-4" *ngIf="ecfBanner">
        <div class="alert alert-warning d-flex flex-wrap align-items-center ecf-banner">
          <div class="mr-auto">
            <div class="font-weight-bold">Questionnaire ECF à compléter</div>
            <ng-container *ngIf="ecfBanner.kind === 'one'">
              <div>{{ ecfBanner.societeName }} · à envoyer avant le {{ formatEcfDate(ecfBanner.dueDate) }}</div>
              <div class="text-xs">{{ ecfBanner.completedPoints }} points sur {{ ecfBanner.totalPoints }} complétés</div>
            </ng-container>
            <ng-container *ngIf="ecfBanner.kind === 'many'">
              <div>{{ ecfBanner.count }} questionnaires ECF à compléter · le premier à envoyer avant le {{ formatEcfDate(ecfBanner.nearestDueDate) }}</div>
            </ng-container>
          </div>
          <a class="btn btn-primary" [routerLink]="ecfBanner.link">Compléter</a>
        </div>
      </div>
      <div class="container-fluid">
        <!--Heading presentation CRM-->
        <!--3 Services CRM-->
        <section id="services-1" class="services">
          <div class="container-md section-title">
            <div class="row">
              <div
                class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
              >
                <div
                  class="text-center icon-box"
                  data-aos="fade-up"
                  data-aos-once="true"
                >
                  <div class="icon">
                    <i class="fas fa-business-time fa-fw"></i>
                    <h4 class="title text-dark">
                      Opérations comptables et notes de frais<br />
                    </h4>
                    <p class="description">
                      Enregistrez vos frais freelance !<br />
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
              >
                <div
                  class="text-center icon-box"
                  data-aos="fade-up"
                  data-aos-delay="250"
                  data-aos-once="true"
                >
                  <div class="icon">
                    <i class="fas fa-chart-line fa-fw"></i>
                    <h4 class="title text-dark">
                      Parrainage<br />
                    </h4>
                    <p class="description">
                      Vous recevez 300 Euros HT à chaque cooptation.&nbsp;<br />
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
              >
                <div
                  class="text-center icon-box"
                  data-aos="fade-up"
                  data-aos-delay="500"
                  data-aos-once="true"
                >
                  <div class="icon">
                    <i class="fas fa-user-check fa-fw"></i>
                    <h4 class="title text-dark">
                      Factures sur espace Pro<br />
                    </h4>
                    <p class="description">
                      Établissez vos factures pour plus de sécurité.<br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!--Services CRM cliquables-->
        <section id="services2" class="services2 mb-5">
          <div class="container-md">
            <div class="col-12 p-4">
              <h4
                class="text-dark mt-4 mb-0 text-dark text-center text-dark-444"
                data-aos="fade-up"
              >
                <strong>SERVICES</strong><br />
              </h4>
              <div class="text-center">
                <p
                  class="lead text-dark d-none d-sm-none d-md-none d-lg-inline-block mt-3 text-dark-444"
                  data-aos="fade-up"
                  data-aos-delay="250"
                  style="font-weight: 400; text-align: center"
                >
                  Obtenez toutes les informations dont vous avez besoin pour
                  développer votre activité.<br />
                </p>
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.ACTIONNAIRE,
                  USER_ROLES.GESTIONNAIRE_EXPENSES
                ]"
              >
                <a href="#" [routerLink]="'/dossiers-permanents'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Dossiers permanents</span>
                          </div>
                          <div class="mb-0 text-xs">
                            <span class="description"></span>
                          </div>
                        </div>
                        <div class="col-auto icon">
                          <i class="far fa-folder-open fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
              >
                <a href="#" [routerLink]="'/client-requests'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div
                            class="text-dark font-weight-bold h6 text-sm-left mb-0"
                          >
                            <span class="title">Intranet sécurisé</span>
                          </div>
                          <div class="mb-0 text-xs">
                            <span class="description"></span>
                          </div>
                        </div>
                        <div class="col-auto icon">
                          <i class="far fa-envelope fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.PORTAGE_SALARIAL,
                  USER_ROLES.ACTIONNAIRE
                ]"
              >
                <a href="#" [routerLink]="'/coopting'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Parrainage</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-user-friends fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
              >
                <a href="#" [routerLink]="'/holidays/home'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Gestion des congés</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-umbrella-beach fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <!-- <div
                class="col-md-6 col-xl-3 mb-4" *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"
                [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
              >
                <a href="#" [routerLink]="'/cra'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Compte rendu d'activité</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="far fa-calendar-alt fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
             
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
              >
                <a href="#" [routerLink]="'/cra-1'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Compte rendu d'activité</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="far fa-calendar-alt fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div
                class="col-md-6 col-xl-3 mb-4"   *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)" 
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.PORTAGE_SALARIAL,
                  USER_ROLES.ACTIONNAIRE
                ]"
              >
                <a href="#" [routerLink]="'/expense-note/home'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title"
                              >Opérations comptables et notes de frais</span
                            >
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-sticky-note fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
              >
                <a href="#" [routerLink]="'/visa-fiscal-ecf'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div
                            class="text-dark font-weight-bold h6 text-sm-left mb-0"
                          >
                            <span class="title">Visa fiscal & Ecf</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-gavel fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.ACTIONNAIRE
                ]"
              >
                <a href="#" [routerLink]="'/simulateur'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Simulateurs</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-euro fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
              class="col-md-6 col-xl-3 mb-4"
              [authorizeRole]="[
                USER_ROLES.COMPTABILITE,
                USER_ROLES.ACTIONNAIRE
              ]"
            >
              <a href="#" [routerLink]="'/simulateur-1'">
                <div
                  class="card shadow border-bottom-yellow1 py-3"
                  data-aos="fade-up"
                >
                  <div class="card-body">
                    <div class="row align-items-center no-gutters">
                      <div class="col">
                        <div class="text-dark font-weight-bold h6 mb-0">
                          <span class="title">Simulateurs</span>
                        </div>
                        <div class="mb-0 text-xs"></div>
                      </div>
                      <div class="col-auto icon">
                        <i class="fas fa-euro fa-2x text-gray-400"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.GESTIONNAIRE_EXPENSES]"
              >
                <a href="#" [routerLink]="'/electronic-signature'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Signature électronique</span>
                          </div>
                          <!-- <div class="text-dark2  font-weight-semi-bold h6  text-sm-left  mb-0"><span class="title">Signature électronique</span></div> -->
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-signature fa-2x"
                            style="padding-right: 1px"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div
                class="col-md-6 col-xl-3 mb-4" *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.PORTAGE_SALARIAL
                ]"
              >
                <a href="#" [routerLink]="'/gestion-document'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Mes documents</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-file-download fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.GESTIONNAIRE_EXPENSES]"
              >
                <a href="#" [routerLink]="'/document'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Guides et fiches conseils</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-info-circle fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
              >
                <a href="#" [routerLink]="'/invoice'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Facturation électronique</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-file-invoice fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div
                *ngIf="showBankModule"
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
              >
                <a href="#" [routerLink]="'/banque'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <!-- <span class="span-new">Nouveau</span> -->
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Banque</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-file-invoice fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>             
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
              >
                <a href="#" [routerLink]="'/compte-resultat'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <!-- <span class="span-new">Nouveau</span> -->
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title"
                              >Compte de résultat prévisionnel</span
                            >
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-poll-h fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <!-- <div class="col-md-6 col-xl-3 mb-4" [authorizeRole]="[USER_ROLES.COMPTABILITE]">
    <a href="#" [routerLink]="'/sales-register'">
      <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
        <span class="span-new">Nouveau</span>
        <div class="card-body">
          <div class="row align-items-center no-gutters">
            <div class="col">
              <div class="text-dark font-weight-bold h6 mb-0">
                <span class="title">Suivi des facturations clients</span>
              </div>
              <div class="mb-0 text-xs"></div>
            </div>
            <div class="col-auto icon"><i class="fas fa-chart-line fa-2x text-gray-400"></i></div>
          </div>
        </div>
      </div>
    </a>
  </div>-->
  <div class="col-md-6 col-xl-3 mb-4">
    <a href="#" [routerLink]="'/professionnels-IT'">
      <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
        <!-- <span class="span-new">Nouveau</span> -->
        <div class="card-body">
          <div class="row align-items-center no-gutters">
            <div class="col">
              <div class="text-dark font-weight-bold h6 mb-0">
                <span class="title">Découvrir les meilleurs deals pour les professionnels IT</span>
              </div>
              <div class="mb-0 text-xs"></div>
            </div>
            <div class="col-auto icon">
              <i class="fas fa-poll-h fa-2x text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
  <!-- <div class="col-md-6 col-xl-3 mb-4" *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"   [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"  >
    <a href="#" [routerLink]="'/portee-tracking'">
      <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">

        <div class="card-body">
          <div class="row align-items-center no-gutters">
            <div class="col">
              <div class="text-dark font-weight-bold h6 mb-0">
                <span class="title">Décompte d'activités</span>
              </div>
              <div class="mb-0 text-xs"></div>
            </div>
            <div class="col-auto icon">
              <i class="fas fa-poll-h fa-2x text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div> -->
   <div  class="col-md-6 col-xl-3 mb-4"    [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
  >
    <a href="#" [routerLink]="'/portee-tracking-1'">
      <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
        <!-- <span class="span-new">Nouveau</span> -->

        <div class="card-body">
          <div class="row align-items-center no-gutters">
            <div class="col">
              <div class="text-dark font-weight-bold h6 mb-0">
                <span class="title">Décompte d'activités </span>
              </div>
              <div class="mb-0 text-xs"></div>
            </div>
            <div class="col-auto icon">
              <i class="fas fa-poll-h fa-2x text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
              <div class="col-md-6 col-xl-3 mb-4">
                <a href="#" [routerLink]="'/help'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Manuel d'utilisation</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-info-circle fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.COMPTABILITE]"
                *ngIf="!production"
              >
                <a href="#" [routerLink]="'/dmlm'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title"
                              >Déclarer ma location meublée</span
                            >
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-building fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.PORTAGE_SALARIAL,
                  USER_ROLES.ACTIONNAIRE,
                  USER_ROLES.GESTIONNAIRE_EXPENSES
                ]"
              
              >
                <a href="#" [routerLink]="'/expense-note-1/home'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title"
                              >Opérations comptables et notes de frais</span
                            >
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i class="fas fa-sticky-note fa-2x text-gray-400"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
                            >
                <a href="#" [routerLink]="'/holidays-1/home'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Gestion des congés</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-umbrella-beach fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-6 col-xl-3 mb-4"
                [authorizeRole]="[
                  USER_ROLES.COMPTABILITE,
                  USER_ROLES.PORTAGE_SALARIAL
                ]"
                             >
                <a href="#" [routerLink]="'/gestion-document-1'">
                  <div
                    class="card shadow border-bottom-yellow1 py-3"
                    data-aos="fade-up"
                  >
                    <div class="card-body">
                      <div class="row align-items-center no-gutters">
                        <div class="col">
                          <div class="text-dark font-weight-bold h6 mb-0">
                            <span class="title">Mes documents</span>
                          </div>
                          <div class="mb-0 text-xs"></div>
                        </div>
                        <div class="col-auto icon">
                          <i
                            class="fas fa-file-download fa-2x text-gray-400"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <!--Begin Footer CRM-->
      </div>
    </div>
  </div>
</div>